import React, {  Component } from 'react';
import { connect } from 'react-redux';

import { dropProductSpecsEmail, resetErrorDetails } from '../../../redux/actions';

class ErrorPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			param: {
                userId: '',
                errorDetails: '',
            },
		}
	}
	componentWillMount() {
		const self = this;
		const { userDetails } = self.props.user;
		if(userDetails && userDetails.sso) {
			self.setState({
				param: {
					...self.state.param,
					userId: userDetails.sso
				}
			});
		}
	}
	componentDidMount() {
		window.scrollTo(0, 0);
		const self = this;
		const { param } = self.state;
		const { errorDetails } = self.props.errors;
		if(errorDetails && errorDetails.length && param.userId) {
			// Check if there is any page specific error details to error reducer
			// If yes the drop an error email and clear that list
			let emailMessage = '';
			errorDetails.forEach(error => {
				emailMessage += `Page: ${error.page}`;
				if(error.serviceURL) {
					emailMessage += `, ServiceURL: ${error.serviceURL}`;
				}
				if(error.hybridQueryParams) {
					emailMessage += `, HybridQuerystring: ${error.hybridQueryParams}`;
				}
				if(error.payload) {
					let payload = error.payload;
					if(typeof(payload) === 'object') {
						payload = JSON.stringify(payload);
					}
					emailMessage += `, Payload: ${payload}`;
				}
				if(error.message) {
					emailMessage += `, Message: ${error.message}`;
				}
				emailMessage += `, Status: ${error.status}`;
			});
			self.props.dropProductSpecsEmail({
				...param,
				errorDetails: emailMessage
			}, "emailType=sendErrorInfo", response => {
				self.props.resetErrorDetails();
            });
		}
	}

    render() {
        return (
			<div>
				<br /><br />
				<h2 style={{textTransform: 'none'}}>We are unable to process your request at this time. Please try again later.  If the problem persists, please notify the CustomerNet Help Desk.</h2>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		errors: state.errors,
		user: state.user
	};
};

const mapDispatchToProps = (dispatch) => ({
	dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
	resetErrorDetails: () => dispatch(resetErrorDetails()),
});

ErrorPage = connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
export default ErrorPage;



// WEBPACK FOOTER //
// ./src/App/components/common/ErrorPage/index.js